import * as React from "react";
import styles from "../components/LeftNavigation/DesignerControls/BasicControls.module.css"

function SvgEditIcon() {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><defs></defs><g transform="translate(778 -228)"><rect className={styles.editIconA} width="16" height="16" transform="translate(-778 228)"/><path d="M4.769,10.417v2h2l4-5-1-2Zm8-4a1.087,1.087,0,0,0,0-1l-1-1a1.087,1.087,0,0,0-1,0l-1,1,2,2Z" transform="translate(-778.769 227.583)"/></g></svg>
      );
}

export default SvgEditIcon;